import axios from '../shared/axios';
import * as events from './events';

export function get(forecastbatchid) {
    return axios.get(`/api/ForecastBatch/Get`, { params: { forecastbatchid } });
}

export function batchCreateDrafts(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/ForecastBatch/BatchCreateDrafts`, data)
            .then(result => {
                events.onNotification_CREATED();
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function batchGetDrafts(forecastbatchid) {
    return axios.get(`/api/ForecastBatch/BatchGetDrafts?forecastbatchid=${forecastbatchid}`);
}

export function batchNotify(data, contractid, forecastbatchid) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/ForecastBatch/BatchNotify`, data, { params: { contractid, forecastbatchid } })
            .then(result => {
                events.onNotification_COMMUNICATED();
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function getRegisterList(contractid, notificationtype) {
    return axios.get(`/api/ForecastBatch/RegisterList`, { params: { contractid, notificationtype } });
}

export function importForecastBatches(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/ForecastBatch/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deleteForecastBatchDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/ForecastBatch/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicateForecastBatchDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/ForecastBatch/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}